function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48 25c-2.324 11.099-2.613 21.981-7.117 28.854-3.521 5.373-8.459-15.115-13.31-15.115-5.012 0-9.188 20.274-12.7 14.578-4.235-6.869-5.001-16.137-6.914-28.318-2.67-17 11.04-15 19.478-13.359C36 9.999 51.559 7.999 48 24.999z",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 13c-10-1-8 11-6 20",
  fill: "none",
  stroke: "var(--primary-color, #000)"
});

var SvgTooth = function SvgTooth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTooth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tooth.081ca248.svg";
export { ForwardRef as ReactComponent };